export const LOGIN_ENC_PUB_KEY =
  '-----BEGIN PUBLIC KEY-----\n' +
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAn+H60UfXEWsesCbOs03A\n' +
  'TBS2mqvMcJD0+dmPSiyxORic2cjj3Gplaih0A5MZN8b40+8bQP4SxJPe/bAw2ssc\n' +
  'djE2DchpRe30WPHODyASW+/VoSJQvQOqSqP39LTTEdhxQVvV54KHPYfWnsRRaHP0\n' +
  'XOnmWjnc5Z/d6pcZwIsMpI1hFnie3AEgeDigrctP3OH8qVkSKc5Vq8dRQc1wsLME\n' +
  'GSlo74mWaHpkGOo8EWsTttkKUZI8pB8mbhi4+o/YT9v5MUF31+5EVtogkDc9kiWq\n' +
  'GdzuF199v5UIpqTmTxWy8z4oj7EcKt/rH8zgBMEVqJjrYb5L/YFvV8icYc0wEPJG\n' +
  'cQIDAQAB\n' +
  '-----END PUBLIC KEY-----'

const getCookieNameWithSuffix = (name: string) => {
  const environment = process.env.REACT_APP_ENV

  return name + '_' + environment
}

export const AppCookies: any = {
  token: getCookieNameWithSuffix('super-admin-token'),
  email: getCookieNameWithSuffix('email'),
  role: getCookieNameWithSuffix('role'),
  role_id: getCookieNameWithSuffix('role_id'),
  forgot_password: getCookieNameWithSuffix('forgot_password'),
  first_name: getCookieNameWithSuffix('first_name'),
  last_name: getCookieNameWithSuffix('last_name'),
  user: getCookieNameWithSuffix('user'),
  has_kindergarten: getCookieNameWithSuffix('has_kindergarten'),
  has_zero_students_classrooms: getCookieNameWithSuffix(
    'has_zero_students_classrooms'
  ),
  profile_color_code: getCookieNameWithSuffix('profile_color_code'),
  support_pin: getCookieNameWithSuffix('support_pin'),
  grade_id: getCookieNameWithSuffix('grade_id'),
  subject_id: getCookieNameWithSuffix('subject_id'),
  classroom_id: getCookieNameWithSuffix('classroom_id'),
  assessmentName: getCookieNameWithSuffix('assessmentName'),
  test_name: getCookieNameWithSuffix('test_name'),
  showSurvey: getCookieNameWithSuffix('showSurvey'),
  isMath: getCookieNameWithSuffix('isMath')
}
